<template>
  <v-card elevation="6" class="my-4 mx-4">
    <v-card-title class="mx-7 my-4" style="color:#AF8936">
      <h2 style="word-break: initial;">Recuperar Contraseña</h2>
      <div class="flex-grow-1"></div>
    </v-card-title>
    <v-form class="mx-10" @submit.prevent="save" ref="form" v-model="valid" lazy-validation>
      <v-card flat>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="pass.newPassword"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="[v => v.length >= 8 || 'Requiere mínimo 8 caracteres']"
                minlength="8"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="pass.newPassword_confirmation"
                :append-icon="shownewPassword ? 'mdi-eye' : 'mdi-eye-off'"
                label="Confirmar Nueva Contraseña"
                :type="shownewPassword ? 'text' : 'password'"
                counter
                @click:append="shownewPassword = !shownewPassword"
                :rules="[this.pass.newPassword === this.pass.newPassword_confirmation || 'Las contraseñas no coinciden']"
                minlength="8"
                counter=""
              ></v-text-field>
            </v-col>

          <v-divider></v-divider>
          <v-btn block color="primary" @click="cambiarPassword()" class="my-5" :disabled="!valid">
            Actualizar Contraseña
            <!-- <v-icon>mdi-content-save</v-icon> -->
          </v-btn>
        </v-row>
        </v-card-text>
      </v-card>
    </v-form>
    <br>
  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'
  const Swal = require('sweetalert2');

  export default {
    data: () => ({
      valid: true,
      pass:{
        newPassword:'',
        newPassword_confirmation:'',
      },
      defaultData:{
        newPassword:'',
        newPassword_confirmation:'',
      },
      showcurrentPassword: '',
      shownewPassword: ''
    }),
    created() {
      this.$store.commit("SET_LAYOUT", "dashboard-layout");
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "isLoggedIn"
      ])
    },
    methods: {
      cambiarPassword(pass) {
        if (this.$refs.form.validate()) {
          this.$store.dispatch("RESET_PASSWORD", { url:"/user/recovery-pass",
          data: {
              token: this.$route.query.token,
              pass: this.pass.newPassword
            }
          }).then(response => {
            // console.log(response)
            if(response.data.status == 'ok'){
            this.$swal({
                icon: 'success',
                title: 'Contraseña actualizada correctamente',
                confirmButtonText: "Aceptar"
              })
              this.$router.push("/login")
            }
          })
          .catch(error => {
            console.log(error.response.data);
            this.$swal({
              icon: 'error',
              title: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            })
          });
        }
      },
    }
  };
</script>
